import { TComplimentaryGroup } from 'pages/dimensions/store/dimensions';
import { getProductsWithRequiredData } from './get-products-with-required-data';

export const getFormattedComplimentaryGroups = (complimentaryGroups: TComplimentaryGroup[] | null) => {
  const complimentaryGroupsArray = complimentaryGroups ?? [];
  const complimentaryGroupsWithCorrectData = complimentaryGroupsArray.map((group: TComplimentaryGroup) => ({
    ...group,
    products: getProductsWithRequiredData(group.products),
  }));

  return complimentaryGroupsWithCorrectData.filter(group => Boolean(group.products.length));
};
